<template>
  <div v-if="!isDismissed" class="banner">
    <div class="banner-content">
      <div class="banner-body">
        <slot />
      </div>
      <div class="banner-actions">
        <slot name="actions" />
        <CButton icon="close" @click="dismiss">
          {{ t('common:emailConfirmation.closeButton') }}
        </CButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useTranslation } from '@/composables/plugins';

const props = defineProps<{
  dismissStorageKey?: string;
}>();

const { t } = useTranslation();

const isDismissed = ref(false);

onMounted(() => {
  if (
    props.dismissStorageKey &&
    sessionStorage.getItem(props.dismissStorageKey)
  ) {
    isDismissed.value = true;
  }
});

function dismiss() {
  isDismissed.value = true;
  if (props.dismissStorageKey) {
    sessionStorage.setItem(props.dismissStorageKey, 'true');
  }
}
</script>

<style scoped>
.banner {
  background-color: var(--amber-200);
  padding: 1rem;
  width: 100%;
  position: fixed;
  top: var(--header-height, 3.75rem);
  z-index: 100;
}

.banner-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 75rem;
  margin: 0 auto;
  gap: 1rem;
}

.banner-body {
  display: flex;
  align-items: center;
}

.banner-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}
</style>
